module.exports = __webpack_public_path__ + "media/assets/images/blog/DALL·E_voice_bot-small-f77fb2448229fe5932257a656e292ffa.png";